export const formatCoveragePreview = (preview) => {
  if (!preview?.coverageColumns?.length) return 'Sin columnas detectadas';

  return preview.coverageColumns
    .map(
      (column) => `${column} (${preview.selectedCoverageCounts?.[column] || 0})`
    )
    .join(', ');
};
